import { InjectionToken } from '@angular/core';
import { II18nConfig } from './i18n.type';

export const BIXI_I18N = new InjectionToken<II18nConfig>('bixi.buildIn.i18n');
